<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #ece7e0;">
          <h5 class="card-title">Gestión de Personas</h5>
          <div class="row mb-3">
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Buscar por: </label>
                  <select 
                    v-model="filters.bpor" 
                    class="form-select form-sm" 
                  >
                    <option value="">-- Buscar Por --</option>
                    <option value="carnet_identidad">Carnet de Identidad</option>
                    <option value="nombres">Nombre</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.criterio"
                    class="form-control form-sm"
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('tramite_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round btn-sm me-2"
              >
                <i class="fa fa-plus me-1"></i> Nueva Persona
              </BButton>
              <BButton
                v-if="hasPermission('tramite_create')"
                variant="danger"
                class="btn-round btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Nro. CI.</th>
                    <th>Nombre Completo</th>
                    <th>Nro. Celular</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="persona in personas" :key="persona.id">
                    <td>{{ persona.carnet_identidad }}</td>
                    <td>{{ persona.nombres }} {{ persona.paterno }} {{ persona.materno }}</td>
                    <td>{{ persona.celular }}</td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          v-if="hasPermission('tramite_update')"
                          @click="showModal(persona)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('tramite_delete')"
                          @click="confirmDelete(persona)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Nro. Carnet Identidad</label>
              <input
                type="text"
                v-model="form.carnet_identidad"
                class="form-control"
                :class="{ 'is-invalid': errors.carnet_identidad }"
                required
              />
              <div class="invalid-feedback" v-if="errors.carnet_identidad">
                {{ errors.carnet_identidad[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label class="form-label">Expedido</label>
              <select
                v-model="form.expedido"
                class="form-select"
                :class="{ 'is-invalid': errors.expedido }"
                required
              >
                <option value="BEN">Beni</option>
                <option value="CHU">Chuquisaca</option>
                <option value="CBB">Cochabamba</option>
                <option value="LPZ">La Paz</option>
                <option value="ORU">Oruro</option>
                <option value="PND">Pando</option>
                <option value="PTO">Potosi</option>
                <option value="SCZ">Santa Cruz</option>
                <option value="TRJ">Tarija</option>
              </select>
              <div class="invalid-feedback" v-if="errors.expedido">
                {{ errors.expedido[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Nro. Celular</label>
              <input
                type="text"
                v-model="form.celular"
                class="form-control"
                :class="{ 'is-invalid': errors.celular }"
                required
              />
              <div class="invalid-feedback" v-if="errors.celular">
                {{ errors.celular[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Nombres</label>
              <input
                type="text"
                v-model="form.nombres"
                class="form-control"
                :class="{ 'is-invalid': errors.nombres }"
                required
              />
              <div class="invalid-feedback" v-if="errors.nombres">
                {{ errors.nombres[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Apellido Paterno</label>
              <input
                type="text"
                v-model="form.paterno"
                class="form-control"
                :class="{ 'is-invalid': errors.paterno }"
                required
              />
              <div class="invalid-feedback" v-if="errors.paterno">
                {{ errors.paterno[0] }}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Apellido Materno</label>
              <input
                type="text"
                v-model="form.materno"
                class="form-control"
                :class="{ 'is-invalid': errors.materno }"
                required
              />
              <div class="invalid-feedback" v-if="errors.materno">
                {{ errors.materno[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Persona {
  id: number;
  carnet_identidad: string;
  expedido: string;
  nombres: string;
  paterno: string;
  materno: string;
  celular: string;
}

interface FormData {
  id: number | null;
  carnet_identidad: string;
  expedido: string;
  nombres: string;
  paterno: string;
  materno: string;
  celular: string;
}

interface Filters {
  bpor: string;
  criterio: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const personas = ref<Persona[]>([]);
    const loading = ref(true);
    const authStore = useAuthStore();
    const filters = ref<Filters>({
      bpor: '',
      criterio: ''
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});

    const form = ref<FormData>({
      id: null,
      carnet_identidad: '',
      expedido: '',
      nombres: '',
      paterno: '',
      materno: ''
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Persona' : 'Nuevo Persona';
    });

    const showModal = (persona: Persona | null) => {
      errors.value = {};
      if (persona) {
        // Edición
        isEditing.value = true;
        form.value = {
          id: persona.id,
          carnet_identidad: persona.carnet_identidad,
          expedido: persona.expedido,
          nombres: persona.nombres,
          paterno: persona.paterno,
          materno: persona.materno,
          celular: persona.celular
        };
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          carnet_identidad: '',
          expedido: '',
          nombres: '',
          paterno: '',
          materno: '',
          celular: ''
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/persona/update/${form.value.id}`, form.value);
        } else {
          response = await axios.post('/persona/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchPersona();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchPersona = async () => {
      loading.value = true;
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.bpor) {
          params.bpor = filters.value.bpor;
        }
        if (filters.value.criterio) {
          params.criterio = filters.value.criterio;
        }
        
        const response = await axios.get('/persona/list', { params });
        personas.value = response.data.personas.data || response.data.personas;
        
        // Actualizar paginación si la API la soporta
        if (response.data.personas.meta) {
          pagination.value = {
            current_page: response.data.personas.meta.current_page,
            per_page: response.data.personas.meta.per_page,
            total: response.data.personas.meta.total,
            last_page: response.data.personas.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar personas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los personas'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchPersona();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchPersona();
    };
    
    const confirmDelete = (persona: Persona) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la sección ${persona.nombres}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deletePersona(persona.id);
        }
      });
    };
    
    const deletePersona = async (id: number) => {
      try {
        await axios.delete(`/persona/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Persona eliminada',
          text: 'La persona ha sido eliminada correctamente'
        });
        await fetchPersona();
      } catch (error: any) {
        console.error('Error al eliminar persona:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la persona'
        });
      }
    };

    const generatePDF = () => {
      // Lógica para generar PDF
      const params = filters.value.id_unidad ? { id_unidad: filters.value.id_unidad } : {};
      
      axios.get('/persona/generate-pdf', { 
        params,
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'personas.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchPersona();
    });
    
    return {
      personas,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
</style>